var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1. Monetory Money") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,46.43A22.43,22.43,0,1,1,46.44,24,22.45,22.45,0,0,1,24,46.43ZM24,3.57A20.43,20.43,0,1,0,44.44,24,20.45,20.45,0,0,0,24,3.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,25c-4.58,0-8.17-2.6-8.17-5.91s3.59-5.91,8.17-5.91c4.19,0,7.68,2.26,8.12,5.26a1,1,0,0,1-.84,1.14,1,1,0,0,1-1.14-.85c-.29-2-3-3.55-6.14-3.55-3.35,0-6.17,1.79-6.17,3.91S20.65,23,24,23a1,1,0,0,1,0,2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24,34.82c-4.19,0-7.68-2.26-8.13-5.26a1,1,0,1,1,2-.29c.3,2,3,3.55,6.15,3.55,3.35,0,6.17-1.79,6.17-3.91S27.35,25,24,25a1,1,0,0,1,0-2c4.58,0,8.17,2.6,8.17,5.91S28.58,34.82,24,34.82Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24,38.65a1,1,0,0,1-1-1V10.35a1,1,0,0,1,2,0v27.3A1,1,0,0,1,24,38.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRates);
export default __webpack_public_path__ + "static/media/rates.5455f67110beb32d2fa44d208159d90f.svg";
export { ForwardRef as ReactComponent };